import Swiper from "swiper";
import {Thumbs} from "swiper/modules";

export const product = () => {
  const slider = document.querySelector('.description-product .block__slider') as HTMLDivElement
  const thumbnails = document.querySelector('.description-product .block__thumbnail') as HTMLDivElement

  if (!slider || !thumbnails) return;

  const sliderThumb = new Swiper(thumbnails, {
    spaceBetween: 16,
    slidesPerView: 5,
    freeMode: true,
    watchSlidesProgress: true,
  })

  new Swiper(slider, {
    modules: [Thumbs],
    spaceBetween: 16,
    slidesPerView: 1,
    thumbs: {
      swiper: sliderThumb,
    },
  })
}
